/**
 * A language, as an ISO 639-1 code — the tag primary stores on anything it localizes, from a
 * patient's preferred language to a notification content's per-language body. A handful of entries
 * are not two-letter 639-1 codes (`ase`, `cmn`, `fil`, `hmn`, `ium`, `mix`, `pt-BR`); they are the
 * tags the vendors we speak to actually accept.
 */
export var Language;
(function (Language) {
    Language["Aa"] = "aa";
    Language["Ab"] = "ab";
    Language["Ae"] = "ae";
    Language["Af"] = "af";
    Language["Ak"] = "ak";
    Language["Am"] = "am";
    Language["An"] = "an";
    Language["Ar"] = "ar";
    Language["As"] = "as";
    Language["Ase"] = "ase";
    Language["Av"] = "av";
    Language["Ay"] = "ay";
    Language["Az"] = "az";
    Language["Ba"] = "ba";
    Language["Be"] = "be";
    Language["Bg"] = "bg";
    Language["Bh"] = "bh";
    Language["Bi"] = "bi";
    Language["Bm"] = "bm";
    Language["Bn"] = "bn";
    Language["Bo"] = "bo";
    Language["Br"] = "br";
    Language["Bs"] = "bs";
    Language["Ca"] = "ca";
    Language["Ce"] = "ce";
    Language["Ch"] = "ch";
    Language["Cmn"] = "cmn";
    Language["Co"] = "co";
    Language["Cr"] = "cr";
    Language["Cs"] = "cs";
    Language["Cu"] = "cu";
    Language["Cv"] = "cv";
    Language["Cy"] = "cy";
    Language["Da"] = "da";
    Language["De"] = "de";
    Language["Dv"] = "dv";
    Language["Ee"] = "ee";
    Language["El"] = "el";
    Language["En"] = "en";
    Language["Eo"] = "eo";
    Language["Es"] = "es";
    Language["Et"] = "et";
    Language["Eu"] = "eu";
    Language["Fa"] = "fa";
    Language["Ff"] = "ff";
    Language["Fi"] = "fi";
    Language["Fil"] = "fil";
    Language["Fj"] = "fj";
    Language["Fo"] = "fo";
    Language["Fr"] = "fr";
    Language["Fy"] = "fy";
    Language["Ga"] = "ga";
    Language["Gd"] = "gd";
    Language["Gl"] = "gl";
    Language["Gn"] = "gn";
    Language["Gu"] = "gu";
    Language["Gv"] = "gv";
    Language["Ha"] = "ha";
    Language["He"] = "he";
    Language["Hi"] = "hi";
    Language["Hmn"] = "hmn";
    Language["Ho"] = "ho";
    Language["Hr"] = "hr";
    Language["Ht"] = "ht";
    Language["Hu"] = "hu";
    Language["Hy"] = "hy";
    Language["Hz"] = "hz";
    Language["Ia"] = "ia";
    Language["Id"] = "id";
    Language["Ie"] = "ie";
    Language["Ig"] = "ig";
    Language["Ii"] = "ii";
    Language["Ik"] = "ik";
    Language["Io"] = "io";
    Language["Is"] = "is";
    Language["It"] = "it";
    Language["Iu"] = "iu";
    Language["Ium"] = "ium";
    Language["Ja"] = "ja";
    Language["Jv"] = "jv";
    Language["Ka"] = "ka";
    Language["Kg"] = "kg";
    Language["Ki"] = "ki";
    Language["Kj"] = "kj";
    Language["Kk"] = "kk";
    Language["Kl"] = "kl";
    Language["Km"] = "km";
    Language["Kn"] = "kn";
    Language["Ko"] = "ko";
    Language["Kr"] = "kr";
    Language["Ks"] = "ks";
    Language["Ku"] = "ku";
    Language["Kv"] = "kv";
    Language["Kw"] = "kw";
    Language["Ky"] = "ky";
    Language["La"] = "la";
    Language["Lb"] = "lb";
    Language["Lg"] = "lg";
    Language["Li"] = "li";
    Language["Ln"] = "ln";
    Language["Lo"] = "lo";
    Language["Lt"] = "lt";
    Language["Lu"] = "lu";
    Language["Lv"] = "lv";
    Language["Mg"] = "mg";
    Language["Mh"] = "mh";
    Language["Mi"] = "mi";
    Language["Mix"] = "mix";
    Language["Mk"] = "mk";
    Language["Ml"] = "ml";
    Language["Mn"] = "mn";
    Language["Mr"] = "mr";
    Language["Ms"] = "ms";
    Language["Mt"] = "mt";
    Language["My"] = "my";
    Language["Na"] = "na";
    Language["Nb"] = "nb";
    Language["Nd"] = "nd";
    Language["Ne"] = "ne";
    Language["Ng"] = "ng";
    Language["Nl"] = "nl";
    Language["Nn"] = "nn";
    Language["No"] = "no";
    Language["Nr"] = "nr";
    Language["Nv"] = "nv";
    Language["Ny"] = "ny";
    Language["Oc"] = "oc";
    Language["Oj"] = "oj";
    Language["Om"] = "om";
    Language["Or"] = "or";
    Language["Os"] = "os";
    Language["Pa"] = "pa";
    Language["Pi"] = "pi";
    Language["Pl"] = "pl";
    Language["Ps"] = "ps";
    Language["Pt"] = "pt";
    Language["PtBr"] = "pt-BR";
    Language["Qu"] = "qu";
    Language["Rm"] = "rm";
    Language["Rn"] = "rn";
    Language["Ro"] = "ro";
    Language["Ru"] = "ru";
    Language["Rw"] = "rw";
    Language["Sa"] = "sa";
    Language["Sc"] = "sc";
    Language["Sd"] = "sd";
    Language["Se"] = "se";
    Language["Sg"] = "sg";
    Language["Si"] = "si";
    Language["Sk"] = "sk";
    Language["Sl"] = "sl";
    Language["Sm"] = "sm";
    Language["Sn"] = "sn";
    Language["So"] = "so";
    Language["Sq"] = "sq";
    Language["Sr"] = "sr";
    Language["Ss"] = "ss";
    Language["St"] = "st";
    Language["Su"] = "su";
    Language["Sv"] = "sv";
    Language["Sw"] = "sw";
    Language["Ta"] = "ta";
    Language["Te"] = "te";
    Language["Tg"] = "tg";
    Language["Th"] = "th";
    Language["Ti"] = "ti";
    Language["Tk"] = "tk";
    Language["Tl"] = "tl";
    Language["Tn"] = "tn";
    Language["To"] = "to";
    Language["Tr"] = "tr";
    Language["Ts"] = "ts";
    Language["Tt"] = "tt";
    Language["Tw"] = "tw";
    Language["Ty"] = "ty";
    Language["Ug"] = "ug";
    Language["Uk"] = "uk";
    Language["Ur"] = "ur";
    Language["Uz"] = "uz";
    Language["Ve"] = "ve";
    Language["Vi"] = "vi";
    Language["Vo"] = "vo";
    Language["Wa"] = "wa";
    Language["Wo"] = "wo";
    Language["Xh"] = "xh";
    Language["Yi"] = "yi";
    Language["Yo"] = "yo";
    Language["Za"] = "za";
    Language["Zh"] = "zh";
    Language["Zu"] = "zu";
})(Language || (Language = {}));
//# sourceMappingURL=language.js.map